import { all } from 'utils/countries';

const supportedCountryCodes = [
  'AR',
  'AU',
  'AT',
  'BE',
  'BR',
  'BG',
  'CA',
  'CL',
  'CO',
  'HR',
  'CZ',
  'DK',
  'EE',
  'FI',
  'FR',
  'DE',
  'HU',
  'IE',
  'IT',
  'LV',
  'LT',
  'LU',
  'MY',
  'MX',
  'NL',
  'NO',
  'NZ',
  'PL',
  'PT',
  'PR',
  'SG',
  'SK',
  'SI',
  'ES',
  'SE',
  'CH',
  'GB',
  'US',
];

export const supportedCountries = all.filter((country) =>
  supportedCountryCodes.includes(country.alpha2)
);
